export const urls = {
  getCues: (videoId: number) => `/video-cues/v1/video-cues/${videoId}`
};